import { useCallback } from "react"
import { batch } from "@preact/signals-react"

import { adminScrapingDataReviewDetails, adminScrapingDataReviewTableDataIndexed } from "../@signals"


export default function useAdminScrapingDataReviewList(rowData={}) {
	const handleClickDetails = useCallback(() => batch(() => {
		adminScrapingDataReviewDetails.value = {
			...adminScrapingDataReviewTableDataIndexed.value[rowData.id][0],
			...rowData
		}
	}), [JSON.stringify(rowData)])

	return { handleClickDetails }
}